
    import styled, { createGlobalStyle } from 'styled-components';
    import footer from './components/footer.js';
    import fonts from './components/fonts.js';

    const FontFamily = 
    {
        SansSerif: "\"CNN\", \"CNN Sans Display\", \"CNN Sans\", \"Helvetica Neue\", Helvetica, Utkal, Arial, sans-serif",
        Serif: "Georgia, \"Times New Roman\", Times, serif",
        Condensed: "\"CNN Condensed\", \"CNN\", \"CNN Sans Display\", \"CNN Sans\", \"Helvetica Neue\", Helvetica, Utkal, Arial, sans-serif",
        Business: "\"Barlow Semi Condensed\", \"CNN Condensed\", \"CNN\", \"CNN Sans Display\", \"CNN Sans\", \"Helvetica Neue\", Helvetica, Utkal, Arial, sans-serif, \"CNN\", \"CNN Sans Display\", \"CNN Sans\", \"Helvetica Neue\", Helvetica, Utkal, Arial, sans-serif",
        Monospace: "Menlo, Monaco, Consolas, \"Courier New\", monospace",
        Base: "\"CNN\", \"CNN Sans Display\", \"CNN Sans\", \"Helvetica Neue\", Helvetica, Utkal, Arial, sans-serif",
    }

    const Theme = 
    {
        breakpoints:
        {
            xs: '@media screen and (max-width: 320px)',
            sm: '@media screen and (min-width: 321px)',
            md: '@media screen and (min-width: 768px)',
            lg: '@media screen and (min-width: 960px)',
            xl: '@media screen and (min-width: 1280px)',
        },

        'cnn-red':  '#CC0000',
        white:      '#ffffff',
        gray1:      '#FEFEFE',
        gray2:      '#F2F2F2',
        gray3:      '#E6E6E6',
        gray4:      '#D9D9D9',
        gray5:      '#BFBFBF',
        gray6:      '#A6A6A6',
        gray7:      '#8C8C8C',
        gray8:      '#737373',
        gray9:      '#595959',
        gray10:     '#404040',
        gray11:     '#262626',
        gray12:     '#1A1A1A',
        gray13:     '#0C0C0C',
        
        nearBlack:  '#0C0C0C',

        black:      '#000000',
        nullGray:   '#D9D9D9',

        bodytextBlack:  '#262626',
        backgroundGray: '#F2F2F2',
        ahref:          '#262626',
        ahrefHover:     '#CC0000',

        red:    '#ff3f3f',
        orange: '#ff7c00',
        yellow: '#f0b100',
        green:  '#4bc88a',
        teal:   '#60b9b1',
        blue:   '#3061f2',
        purple: '#9656d1',
        pink:   '#fc2f59',
        gray:   '#737373',

// us political parties
        demBlue:          "#3061f2",
        repRed:           "#ff3f3f",
        tossupPurple:     "#853dcc",
        libYellow:        "#ffc34c",
        grnGreen:         "#38ba79",
        otherTeal:        "#34d1c9",
        approveGreen:     "#38ba79",
        disapproveOrange: "#ff7c05",
        noOpinion:        "#d9d9d9",

// cnn-business
        cnnBusiness:  "#00c59e",
        bizGreen:     "#00c59e",
        bizRedOrange: "#ff5037",
        bizNight:     "#004969",
        bizSky:       "#00bcf0",
        bizSalmon:    "#ff6674",
        bizGray:      "#a3a3a3",

// Typography
// -------------------------

        sansSerif:  FontFamily.SansSerif,
        condensed:  FontFamily.Condensed,
        serif:      FontFamily.Serif,
        monospace:  FontFamily.Monospace,

// Media variables and global queries
// -------------------------

        desktop:    "screen and (min-width: 640px)",
        mobile:     "screen and (max-width: 639px)",

        // Apple devices
        iphone5:     "all and (max-width: 320px)",
        iphone6:     "all and (max-width: 375px)",
        iphone6plus: "all and (max-width: 320px)",
        ipad:        "all and (max-width: 768px)",

        retina:      "\"only screen and (-webkit-min-device-pixel-ratio: 1.5)\", \"only screen and (min--moz-device-pixel-ratio: 1.5)\", \"only screen and (-o-min-device-pixel-ratio: 3/2)\", \"only screen and (min-device-pixel-ratio: 1.5)\"",
    };

    const Reset = createGlobalStyle`
        
        *
        {
            box-sizing: border-box;
        }

        body
        {
            background-color: ${ props => props.backgroundColor || "#FFF" };
            font-family: ${ ({theme}) => theme.sansSerif };
            line-height: 1.45;
            font-weight: 300;
            min-height: 100vh;
            width: 100vw;
            margin: 0;

            ::before
            {
                display: block;
                visibility: hidden;
                position: absolute;
                overflow: hidden;
                color: transparent;
                height: 0px;
                width: 0px;
                left: -1px;
                top: -1px;
            }

            ${({ theme }) => Object.keys(theme.breakpoints).map(val => `${ theme.breakpoints[val] } { ::before { content: '${val}' } }`) };

            &.menuOpen
            {
                overflow: hidden;
            }
        }

        .center
        {
            margin: 0 auto;
        }

        img.src
        {
            display: block;
            vertical-align: middle;
            max-width: 100%;
            height: auto;
            width: 100%;
        }

        .cnnix--ad
        {
            display: block;
            position: relative;
            overflow: hidden;
            text-align: center;
            width: 100%;
        }

        img[src*="d.agkn.com"]
        {
            position: absolute;
        }

        ${ footer }
    `;

    const AppContent = styled.div`
        display: flex;
        position: relative;
        flex-direction: column;
        min-height: 100vh;
        height: 100%;
    `;

    //  Exports
    // ----------

    export { Reset, AppContent, FontFamily };
    export default Theme;
    

